module.exports = __webpack_public_path__ + "static/media/iguazu-falls-14.ac72331c.jpg";